import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function AdminPanel() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [estadisticas, setEstadisticas] = useState(null);
  const [envios, setEnvios] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [enviosPorPaqueteria, setEnviosPorPaqueteria] = useState([]);
  const [recolecciones, setRecolecciones] = useState([]);
  const [actualizandoRec, setActualizandoRec] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabActiva, setTabActiva] = useState('dashboard');
  const [error, setError] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const [modalSaldo, setModalSaldo] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [montoSaldo, setMontoSaldo] = useState('');
  const [descripcionSaldo, setDescripcionSaldo] = useState('');
  const [loadingSaldo, setLoadingSaldo] = useState(false);

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [statsRes, enviosRes, usuariosRes, paqueteriasRes, recoleccionesRes] = await Promise.all([
        api.get('/admin/estadisticas'),
        api.get('/admin/envios'),
        api.get('/admin/usuarios'),
        api.get('/admin/envios-por-paqueteria'),
        api.get('/recolecciones/admin')
      ]);
      setEstadisticas(statsRes.data);
      setEnvios(enviosRes.data);
      setUsuarios(usuariosRes.data);
      setEnviosPorPaqueteria(paqueteriasRes.data);
      setRecolecciones(recoleccionesRes.data);
    } catch (error) {
      console.error('Error:', error);
      if (error.response?.status === 403) setError('No tienes permisos de administrador');
      else setError('Error al cargar datos');
    } finally { setLoading(false); }
  };

  const cambiarEstadoRecoleccion = async (id, estado) => {
    setActualizandoRec(id);
    try {
      await api.patch(`/recolecciones/admin/${id}/estado`, { estado });
      const response = await api.get('/recolecciones/admin');
      setRecolecciones(response.data);
    } catch (error) {
      alert(error.response?.data?.error || 'Error al actualizar estado');
    } finally {
      setActualizandoRec(null);
    }
  };

  const handleLogout = () => { logout(); navigate('/login'); };

  const abrirModalSaldo = (usuario) => { setUsuarioSeleccionado(usuario); setMontoSaldo(''); setDescripcionSaldo(''); setModalSaldo(true); };
  const cerrarModalSaldo = () => { setModalSaldo(false); setUsuarioSeleccionado(null); setMontoSaldo(''); setDescripcionSaldo(''); };

  const handleAgregarSaldo = async () => {
    if (!montoSaldo || parseFloat(montoSaldo) <= 0) { alert('Ingresa un monto válido mayor a 0'); return; }
    setLoadingSaldo(true);
    try {
      const response = await api.post('/admin/agregar-saldo', {
        empresa_id: usuarioSeleccionado.empresa_id,
        monto: parseFloat(montoSaldo),
        descripcion: descripcionSaldo || undefined
      });
      alert(response.data.mensaje);
      cerrarModalSaldo();
      cargarDatos();
    } catch (error) {
      console.error('Error al agregar saldo:', error);
      alert(error.response?.data?.error || 'Error al agregar saldo');
    } finally { setLoadingSaldo(false); }
  };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case 'ENTREGADO': return { bg: '#d1fae5', text: '#065f46' };
      case 'EN TRÁNSITO': case 'EN TRANSITO': return { bg: '#dbeafe', text: '#1e40af' };
      case 'PENDIENTE': return { bg: '#fef3c7', text: '#92400e' };
      case 'CANCELADO': return { bg: '#fee2e2', text: '#991b1b' };
      default: return { bg: '#f3f4f6', text: '#374151' };
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
        <p style={{ fontSize: '1.25rem', color: '#6b7280' }}>Cargando panel de administración...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
        <div style={{ textAlign: 'center', padding: '1rem' }}>
          <p style={{ fontSize: '1.25rem', color: '#991b1b', marginBottom: '1rem' }}>{error}</p>
          <button onClick={() => navigate('/dashboard')} style={{ padding: '0.75rem 1.5rem', backgroundColor: '#ff8c00', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer' }}>Volver al Dashboard</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1f2937' }}>
      {/* Header */}
      <nav style={{ backgroundColor: '#111827', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>
        <div style={{ maxWidth: '90rem', margin: '0 auto', padding: isMobile ? '0 0.5rem' : '0 1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', height: isMobile ? '3.5rem' : '4rem', alignItems: 'center' }}>
            <h1 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.25rem', fontWeight: 'bold' }}>🛡️ Admin</h1>
            {isMobile ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0.5rem', color: 'white' }}>☰</button>
                {menuOpen && (
                  <div style={{ position: 'absolute', right: 0, top: '100%', backgroundColor: '#1f2937', boxShadow: '0 4px 12px rgba(0,0,0,0.3)', borderRadius: '0.5rem', padding: '0.5rem', minWidth: '180px', zIndex: 1000 }}>
                    <button onClick={() => { navigate('/dashboard'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#d1d5db', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Ir al Dashboard</button>
                    <button onClick={handleLogout} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#f87171', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Cerrar Sesión</button>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button onClick={() => navigate('/dashboard')} style={{ padding: '0.5rem 1rem', backgroundColor: '#374151', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.875rem' }}>Ir al Dashboard</button>
                <button onClick={handleLogout} style={{ padding: '0.5rem 1rem', backgroundColor: '#dc2626', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.875rem' }}>Cerrar Sesión</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Tabs */}
      <div style={{ backgroundColor: '#111827', borderBottom: '1px solid #374151' }}>
        <div style={{ maxWidth: '90rem', margin: '0 auto', padding: '0 0.5rem', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <div style={{ display: 'flex', gap: isMobile ? '0.25rem' : '0.5rem', minWidth: isMobile ? 'max-content' : 'auto' }}>
            {['dashboard', 'envios', 'usuarios', 'paqueterias', 'recolecciones'].map(tab => (
              <button key={tab} onClick={() => setTabActiva(tab)} style={{
                padding: isMobile ? '0.75rem 0.75rem' : '1rem 1.5rem',
                backgroundColor: tabActiva === tab ? '#ff8c00' : 'transparent',
                color: 'white', border: 'none', cursor: 'pointer',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                fontWeight: tabActiva === tab ? '600' : '400',
                borderRadius: '0.375rem 0.375rem 0 0', whiteSpace: 'nowrap'
              }}>
                {tab === 'dashboard' && '📊 Dashboard'}
                {tab === 'envios' && '📦 Envíos'}
                {tab === 'usuarios' && '👥 Usuarios'}
                {tab === 'paqueterias' && '🚚 Paqueterías'}
                {tab === 'recolecciones' && '📬 Recolecciones'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '90rem', margin: '0 auto', padding: isMobile ? '1rem 0.5rem' : '2rem 1rem' }}>
        
        {/* TAB: Dashboard */}
        {tabActiva === 'dashboard' && estadisticas && (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: isMobile ? '0.5rem' : '1rem', marginBottom: isMobile ? '1rem' : '2rem' }}>
              <div style={{ backgroundColor: '#065f46', borderRadius: '0.5rem', padding: isMobile ? '0.75rem' : '1.5rem' }}>
                <p style={{ color: '#a7f3d0', fontSize: isMobile ? '0.7rem' : '0.875rem', marginBottom: '0.25rem' }}>💰 Ganancia Total</p>
                <p style={{ color: 'white', fontSize: isMobile ? '1.25rem' : '2rem', fontWeight: 'bold' }}>${estadisticas.gananciaTotales?.toFixed(2)}</p>
                <p style={{ color: '#a7f3d0', fontSize: '0.7rem', marginTop: '0.25rem' }}>Comisión acumulada</p>
              </div>
              <div style={{ backgroundColor: '#1e40af', borderRadius: '0.5rem', padding: isMobile ? '0.75rem' : '1.5rem' }}>
                <p style={{ color: '#bfdbfe', fontSize: isMobile ? '0.7rem' : '0.875rem', marginBottom: '0.25rem' }}>📦 Envíos Totales</p>
                <p style={{ color: 'white', fontSize: isMobile ? '1.25rem' : '2rem', fontWeight: 'bold' }}>{estadisticas.totalEnvios}</p>
                <p style={{ color: '#bfdbfe', fontSize: '0.7rem', marginTop: '0.25rem' }}>Hoy: {estadisticas.enviosHoy} | Mes: {estadisticas.enviosMes}</p>
              </div>
              <div style={{ backgroundColor: '#7c3aed', borderRadius: '0.5rem', padding: isMobile ? '0.75rem' : '1.5rem' }}>
                <p style={{ color: '#ddd6fe', fontSize: isMobile ? '0.7rem' : '0.875rem', marginBottom: '0.25rem' }}>💵 Ingresos Totales</p>
                <p style={{ color: 'white', fontSize: isMobile ? '1.25rem' : '2rem', fontWeight: 'bold' }}>${estadisticas.ingresosTotales?.toFixed(2)}</p>
                <p style={{ color: '#ddd6fe', fontSize: '0.7rem', marginTop: '0.25rem' }}>Mes: ${estadisticas.ingresosMes?.toFixed(2)}</p>
              </div>
              <div style={{ backgroundColor: '#dc2626', borderRadius: '0.5rem', padding: isMobile ? '0.75rem' : '1.5rem' }}>
                <p style={{ color: '#fecaca', fontSize: isMobile ? '0.7rem' : '0.875rem', marginBottom: '0.25rem' }}>👥 Usuarios</p>
                <p style={{ color: 'white', fontSize: isMobile ? '1.25rem' : '2rem', fontWeight: 'bold' }}>{estadisticas.totalUsuarios}</p>
                <p style={{ color: '#fecaca', fontSize: '0.7rem', marginTop: '0.25rem' }}>Empresas: {estadisticas.totalEmpresas}</p>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '0.5rem' : '1rem' }}>
              <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', padding: isMobile ? '1rem' : '1.5rem' }}>
                <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600', marginBottom: '1rem' }}>📅 Este Mes</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div>
                    <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Envíos</p>
                    <p style={{ color: 'white', fontSize: isMobile ? '1.125rem' : '1.5rem', fontWeight: 'bold' }}>{estadisticas.enviosMes}</p>
                  </div>
                  <div>
                    <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Ganancia</p>
                    <p style={{ color: '#10b981', fontSize: isMobile ? '1.125rem' : '1.5rem', fontWeight: 'bold' }}>${estadisticas.gananciaMes?.toFixed(2)}</p>
                  </div>
                </div>
              </div>
              <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', padding: isMobile ? '1rem' : '1.5rem' }}>
                <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600', marginBottom: '1rem' }}>📊 Envíos por Estado</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {estadisticas.enviosPorEstado?.map((item, index) => {
                    const color = getStatusColor(item.status);
                    return (
                      <div key={index} style={{ backgroundColor: color.bg, color: color.text, padding: '0.375rem 0.75rem', borderRadius: '9999px', fontSize: isMobile ? '0.75rem' : '0.875rem', fontWeight: '600' }}>
                        {item.status || 'Sin estado'}: {item.total}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* TAB: Envíos */}
        {tabActiva === 'envios' && (
          <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid #4b5563' }}>
              <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600' }}>📦 Últimos 100 Envíos</h3>
            </div>
            {isMobile ? (
              /* Mobile: Card view for envios */
              <div style={{ padding: '0.5rem', display: 'grid', gap: '0.5rem' }}>
                {envios.map((envio) => {
                  const statusColor = getStatusColor(envio.status);
                  const ganancia = parseFloat(envio.costo_cliente || 0) - parseFloat(envio.costo_pak2go || 0);
                  return (
                    <div key={envio.id} style={{ backgroundColor: '#1f2937', borderRadius: '0.5rem', padding: '0.75rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <span style={{ color: 'white', fontSize: '0.8rem', fontWeight: '600' }}>{envio.numero_guia}</span>
                        <span style={{ backgroundColor: statusColor.bg, color: statusColor.text, padding: '0.2rem 0.5rem', borderRadius: '9999px', fontSize: '0.65rem', fontWeight: '600' }}>{envio.status}</span>
                      </div>
                      <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: '0.2rem 0' }}>{envio.cliente_nombre || envio.cliente_email || '-'} • {envio.paqueteria}</p>
                      <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0' }}>
                        {envio.origen_ciudad} → {envio.destino_ciudad}
                      </p>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '1px solid #374151' }}>
                        <span style={{ color: '#9ca3af', fontSize: '0.7rem' }}>Cliente: <span style={{ color: 'white' }}>${parseFloat(envio.costo_cliente || 0).toFixed(2)}</span></span>
                        <span style={{ color: '#9ca3af', fontSize: '0.7rem' }}>Costo: <span style={{ color: '#f87171' }}>${parseFloat(envio.costo_pak2go || 0).toFixed(2)}</span></span>
                        <span style={{ color: '#9ca3af', fontSize: '0.7rem' }}>Ganancia: <span style={{ color: '#10b981', fontWeight: '600' }}>${ganancia.toFixed(2)}</span></span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1f2937' }}>
                      {['GUÍA', 'CLIENTE', 'PAQUETERÍA', 'ORIGEN → DESTINO', 'ESTADO', 'CLIENTE PAGÓ', 'COSTO', 'GANANCIA', 'FECHA'].map(h => (
                        <th key={h} style={{ padding: '0.75rem', textAlign: h.includes('PAGÓ') || h === 'COSTO' || h === 'GANANCIA' ? 'right' : 'left', color: '#9ca3af', fontSize: '0.75rem', fontWeight: '600' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {envios.map((envio, index) => {
                      const statusColor = getStatusColor(envio.status);
                      const ganancia = parseFloat(envio.costo_cliente || 0) - parseFloat(envio.costo_pak2go || 0);
                      return (
                        <tr key={envio.id} style={{ borderBottom: '1px solid #4b5563', backgroundColor: index % 2 === 0 ? '#374151' : '#3f4a5a' }}>
                          <td style={{ padding: '0.75rem', color: 'white', fontSize: '0.875rem', fontWeight: '500' }}>{envio.numero_guia}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.875rem' }}>{envio.cliente_nombre || envio.cliente_email || '-'}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.875rem' }}>{envio.paqueteria}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem' }}>{envio.origen_ciudad}, {envio.origen_estado?.substring(0,3)} → {envio.destino_ciudad}, {envio.destino_estado?.substring(0,3)}</td>
                          <td style={{ padding: '0.75rem' }}><span style={{ backgroundColor: statusColor.bg, color: statusColor.text, padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600' }}>{envio.status}</span></td>
                          <td style={{ padding: '0.75rem', color: 'white', fontSize: '0.875rem', textAlign: 'right' }}>${parseFloat(envio.costo_cliente || 0).toFixed(2)}</td>
                          <td style={{ padding: '0.75rem', color: '#f87171', fontSize: '0.875rem', textAlign: 'right' }}>${parseFloat(envio.costo_pak2go || 0).toFixed(2)}</td>
                          <td style={{ padding: '0.75rem', color: '#10b981', fontSize: '0.875rem', textAlign: 'right', fontWeight: '600' }}>${ganancia.toFixed(2)}</td>
                          <td style={{ padding: '0.75rem', color: '#9ca3af', fontSize: '0.75rem' }}>{new Date(envio.created_at).toLocaleDateString('es-MX')}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* TAB: Usuarios */}
        {tabActiva === 'usuarios' && (
          <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid #4b5563' }}>
              <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600' }}>👥 Usuarios Registrados ({usuarios.length})</h3>
            </div>
            {isMobile ? (
              <div style={{ padding: '0.5rem', display: 'grid', gap: '0.5rem' }}>
                {usuarios.map((usuario) => (
                  <div key={usuario.id} style={{ backgroundColor: '#1f2937', borderRadius: '0.5rem', padding: '0.75rem' }}>
                    <p style={{ color: 'white', fontSize: '0.85rem', fontWeight: '600', margin: '0 0 0.25rem 0' }}>{usuario.email}</p>
                    <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: '0.15rem 0' }}>{usuario.razon_social || '-'} • {usuario.rfc || '-'}</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', gap: '0.5rem', flexWrap: 'wrap' }}>
                      <span style={{ color: '#10b981', fontSize: '0.8rem', fontWeight: '600' }}>Saldo: ${parseFloat(usuario.saldo || 0).toFixed(2)}</span>
                      <span style={{ color: '#d1d5db', fontSize: '0.8rem' }}>Envíos: {usuario.total_envios}</span>
                      <span style={{ color: '#fbbf24', fontSize: '0.8rem' }}>Gastado: ${parseFloat(usuario.total_gastado || 0).toFixed(2)}</span>
                    </div>
                    <button onClick={() => abrirModalSaldo(usuario)} style={{
                      marginTop: '0.5rem', width: '100%', padding: '0.5rem',
                      backgroundColor: '#10b981', color: 'white', border: 'none',
                      borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.8rem', fontWeight: '600'
                    }}>💰 Agregar Saldo</button>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1f2937' }}>
                      {['EMAIL', 'EMPRESA', 'RFC', 'TELÉFONO', 'SALDO', 'ENVÍOS', 'TOTAL GASTADO', 'REGISTRO', 'ACCIONES'].map(h => (
                        <th key={h} style={{ padding: '0.75rem', textAlign: ['SALDO', 'ENVÍOS', 'TOTAL GASTADO'].includes(h) ? 'right' : h === 'ACCIONES' ? 'center' : 'left', color: '#9ca3af', fontSize: '0.75rem', fontWeight: '600' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios.map((usuario, index) => (
                      <tr key={usuario.id} style={{ borderBottom: '1px solid #4b5563', backgroundColor: index % 2 === 0 ? '#374151' : '#3f4a5a' }}>
                        <td style={{ padding: '0.75rem', color: 'white', fontSize: '0.875rem' }}>{usuario.email}</td>
                        <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.875rem' }}>{usuario.razon_social || '-'}</td>
                        <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.875rem' }}>{usuario.rfc || '-'}</td>
                        <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.875rem' }}>{usuario.telefono || '-'}</td>
                        <td style={{ padding: '0.75rem', color: '#10b981', fontSize: '0.875rem', textAlign: 'right', fontWeight: '600' }}>${parseFloat(usuario.saldo || 0).toFixed(2)}</td>
                        <td style={{ padding: '0.75rem', color: 'white', fontSize: '0.875rem', textAlign: 'right' }}>{usuario.total_envios}</td>
                        <td style={{ padding: '0.75rem', color: '#fbbf24', fontSize: '0.875rem', textAlign: 'right', fontWeight: '600' }}>${parseFloat(usuario.total_gastado || 0).toFixed(2)}</td>
                        <td style={{ padding: '0.75rem', color: '#9ca3af', fontSize: '0.75rem' }}>{new Date(usuario.created_at).toLocaleDateString('es-MX')}</td>
                        <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                          <button onClick={() => abrirModalSaldo(usuario)} style={{ padding: '0.375rem 0.75rem', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.75rem', fontWeight: '600' }}>💰 Agregar Saldo</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* TAB: Paqueterías */}
        {tabActiva === 'paqueterias' && (
          <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid #4b5563' }}>
              <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600' }}>🚚 Envíos por Paquetería</h3>
            </div>
            <div style={{ padding: isMobile ? '0.5rem' : '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))', gap: isMobile ? '0.5rem' : '1rem' }}>
                {enviosPorPaqueteria.map((paq, index) => {
                  const ganancia = parseFloat(paq.ingresos || 0) - parseFloat(paq.costos || 0);
                  return (
                    <div key={index} style={{ backgroundColor: '#1f2937', borderRadius: '0.5rem', padding: isMobile ? '1rem' : '1.5rem' }}>
                      <h4 style={{ color: 'white', fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: 'bold', marginBottom: '0.75rem' }}>{paq.paqueteria}</h4>
                      <div style={{ display: 'grid', gap: '0.375rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Envíos:</span>
                          <span style={{ color: 'white', fontWeight: '600' }}>{paq.total}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Ingresos:</span>
                          <span style={{ color: 'white' }}>${parseFloat(paq.ingresos || 0).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Costos:</span>
                          <span style={{ color: '#f87171' }}>${parseFloat(paq.costos || 0).toFixed(2)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '0.5rem', borderTop: '1px solid #374151' }}>
                          <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Ganancia:</span>
                          <span style={{ color: '#10b981', fontWeight: 'bold' }}>${ganancia.toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* TAB: Recolecciones */}
        {tabActiva === 'recolecciones' && (
          <div style={{ backgroundColor: '#374151', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid #4b5563' }}>
              <h3 style={{ color: 'white', fontSize: isMobile ? '0.9rem' : '1.125rem', fontWeight: '600' }}>📬 Solicitudes de Recolección ({recolecciones.length})</h3>
            </div>
            {recolecciones.length === 0 ? (
              <div style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>No hay solicitudes de recolección</div>
            ) : isMobile ? (
              <div style={{ padding: '0.5rem', display: 'grid', gap: '0.5rem' }}>
                {recolecciones.map((rec) => {
                  const colorEstado = rec.estado === 'confirmada' ? { bg: '#d1fae5', text: '#065f46' }
                    : rec.estado === 'solicitada' ? { bg: '#dbeafe', text: '#1e40af' }
                    : { bg: '#fef3c7', text: '#92400e' };
                  return (
                    <div key={rec.id} style={{ backgroundColor: '#1f2937', borderRadius: '0.5rem', padding: '0.75rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <span style={{ color: 'white', fontSize: '0.85rem', fontWeight: '600' }}>{rec.folio}</span>
                        <span style={{ backgroundColor: colorEstado.bg, color: colorEstado.text, padding: '0.2rem 0.5rem', borderRadius: '9999px', fontSize: '0.65rem', fontWeight: '600', textTransform: 'capitalize' }}>{rec.estado}</span>
                      </div>
                      <p style={{ color: '#d1d5db', fontSize: '0.75rem', margin: '0.2rem 0' }}>{rec.cliente_nombre || rec.cliente_email}</p>
                      <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0' }}>{rec.paqueteria} • Tracking: {rec.tracking}</p>
                      <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0' }}>{rec.contenido}</p>
                      <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0' }}>CP {rec.cp} • {rec.direccion}</p>
                      <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0' }}>Horario: {rec.horario_preferido} • {new Date(rec.created_at).toLocaleDateString('es-MX')}</p>
                      <div style={{ display: 'flex', gap: '0.375rem', marginTop: '0.5rem' }}>
                        <button onClick={() => cambiarEstadoRecoleccion(rec.id, 'solicitada')} disabled={actualizandoRec === rec.id || rec.estado === 'solicitada'} style={{
                          flex: 1, padding: '0.4rem', backgroundColor: rec.estado === 'solicitada' ? '#6b7280' : '#1e40af', color: 'white',
                          border: 'none', borderRadius: '0.25rem', cursor: rec.estado === 'solicitada' ? 'not-allowed' : 'pointer', fontSize: '0.7rem', fontWeight: '600'
                        }}>Solicitada</button>
                        <button onClick={() => cambiarEstadoRecoleccion(rec.id, 'confirmada')} disabled={actualizandoRec === rec.id || rec.estado === 'confirmada'} style={{
                          flex: 1, padding: '0.4rem', backgroundColor: rec.estado === 'confirmada' ? '#6b7280' : '#065f46', color: 'white',
                          border: 'none', borderRadius: '0.25rem', cursor: rec.estado === 'confirmada' ? 'not-allowed' : 'pointer', fontSize: '0.7rem', fontWeight: '600'
                        }}>Confirmada</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#1f2937' }}>
                      {['FOLIO', 'USUARIO', 'PAQUETERÍA', 'TRACKING', 'CONTENIDO', 'CP', 'DIRECCIÓN', 'HORARIO', 'ESTADO', 'FECHA', 'ACCIONES'].map(h => (
                        <th key={h} style={{ padding: '0.75rem', textAlign: 'left', color: '#9ca3af', fontSize: '0.75rem', fontWeight: '600' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {recolecciones.map((rec, index) => {
                      const colorEstado = rec.estado === 'confirmada' ? { bg: '#d1fae5', text: '#065f46' }
                        : rec.estado === 'solicitada' ? { bg: '#dbeafe', text: '#1e40af' }
                        : { bg: '#fef3c7', text: '#92400e' };
                      return (
                        <tr key={rec.id} style={{ borderBottom: '1px solid #4b5563', backgroundColor: index % 2 === 0 ? '#374151' : '#3f4a5a' }}>
                          <td style={{ padding: '0.75rem', color: 'white', fontSize: '0.8rem', fontWeight: '500' }}>{rec.folio}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.8rem' }}>{rec.cliente_nombre || rec.cliente_email}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.8rem' }}>{rec.paqueteria}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem' }}>{rec.tracking}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem', maxWidth: '12rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{rec.contenido}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem' }}>{rec.cp}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem', maxWidth: '14rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{rec.direccion}</td>
                          <td style={{ padding: '0.75rem', color: '#d1d5db', fontSize: '0.75rem', textTransform: 'capitalize' }}>{rec.horario_preferido}</td>
                          <td style={{ padding: '0.75rem' }}><span style={{ backgroundColor: colorEstado.bg, color: colorEstado.text, padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600', textTransform: 'capitalize' }}>{rec.estado}</span></td>
                          <td style={{ padding: '0.75rem', color: '#9ca3af', fontSize: '0.75rem' }}>{new Date(rec.created_at).toLocaleDateString('es-MX')}</td>
                          <td style={{ padding: '0.75rem' }}>
                            <div style={{ display: 'flex', gap: '0.375rem' }}>
                              <button onClick={() => cambiarEstadoRecoleccion(rec.id, 'solicitada')} disabled={actualizandoRec === rec.id || rec.estado === 'solicitada'} style={{
                                padding: '0.375rem 0.625rem', backgroundColor: rec.estado === 'solicitada' ? '#6b7280' : '#1e40af', color: 'white',
                                border: 'none', borderRadius: '0.25rem', cursor: rec.estado === 'solicitada' ? 'not-allowed' : 'pointer', fontSize: '0.7rem', fontWeight: '600'
                              }}>Solicitada</button>
                              <button onClick={() => cambiarEstadoRecoleccion(rec.id, 'confirmada')} disabled={actualizandoRec === rec.id || rec.estado === 'confirmada'} style={{
                                padding: '0.375rem 0.625rem', backgroundColor: rec.estado === 'confirmada' ? '#6b7280' : '#065f46', color: 'white',
                                border: 'none', borderRadius: '0.25rem', cursor: rec.estado === 'confirmada' ? 'not-allowed' : 'pointer', fontSize: '0.7rem', fontWeight: '600'
                              }}>Confirmada</button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal Agregar Saldo */}
      {modalSaldo && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: isMobile ? '1rem' : '0' }}>
          <div style={{ backgroundColor: '#1f2937', borderRadius: '0.75rem', padding: isMobile ? '1.5rem' : '2rem', width: '100%', maxWidth: '28rem', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' }}>
            <h3 style={{ color: 'white', fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: '700', marginBottom: '0.5rem' }}>💰 Agregar Saldo</h3>
            <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginBottom: '0.5rem' }}>{usuarioSeleccionado?.razon_social || usuarioSeleccionado?.email}</p>
            <p style={{ color: '#10b981', fontSize: '0.875rem', marginBottom: '1.5rem' }}>Saldo actual: ${parseFloat(usuarioSeleccionado?.saldo || 0).toFixed(2)}</p>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', color: '#d1d5db', fontSize: '0.875rem', marginBottom: '0.375rem' }}>Monto a agregar *</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ color: '#9ca3af', fontSize: '1.25rem' }}>$</span>
                <input type="number" min="1" value={montoSaldo} onChange={(e) => setMontoSaldo(e.target.value)} placeholder="0.00"
                  style={{ flex: 1, padding: '0.75rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.375rem', color: 'white', fontSize: '1.25rem', boxSizing: 'border-box' }} />
                <span style={{ color: '#9ca3af' }}>MXN</span>
              </div>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', color: '#d1d5db', fontSize: '0.875rem', marginBottom: '0.375rem' }}>Descripción (opcional)</label>
              <input type="text" value={descripcionSaldo} onChange={(e) => setDescripcionSaldo(e.target.value)} placeholder="Ej: Cortesía, ajuste, bonificación..."
                style={{ width: '100%', padding: '0.75rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.375rem', color: 'white', fontSize: '0.875rem', boxSizing: 'border-box' }} />
            </div>

            {montoSaldo && parseFloat(montoSaldo) > 0 && (
              <div style={{ backgroundColor: '#065f46', borderRadius: '0.375rem', padding: '0.75rem', marginBottom: '1.5rem', fontSize: '0.875rem', color: '#a7f3d0' }}>
                Nuevo saldo: <strong style={{ color: 'white' }}>${(parseFloat(usuarioSeleccionado?.saldo || 0) + parseFloat(montoSaldo)).toFixed(2)}</strong>
              </div>
            )}

            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button onClick={cerrarModalSaldo} style={{ flex: 1, padding: '0.75rem', backgroundColor: '#374151', color: '#d1d5db', border: '1px solid #4b5563', borderRadius: '0.375rem', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={handleAgregarSaldo} disabled={loadingSaldo || !montoSaldo || parseFloat(montoSaldo) <= 0} style={{
                flex: 1, padding: '0.75rem', backgroundColor: loadingSaldo ? '#6b7280' : '#10b981', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: loadingSaldo ? 'not-allowed' : 'pointer', fontWeight: '600'
              }}>{loadingSaldo ? 'Agregando...' : 'Agregar Saldo'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPanel;